import gql from 'graphql-tag';

import type { BlogOutlineSection } from 'src/data/blog';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationCreateBlogPostBuilderOutlineSectionArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION } from './schema';

const MUTATION = gql`
  mutation CreateBlogPostBuilderOutlineSection(
    $projectId: ID!
    $draftId: ID!
    $headline: String!
    $order: Int!
    $afterSectionId: ID
    $instructions: String
  ) {
    createBlogPostBuilderOutlineSection(
      projectId: $projectId
      draftId: $draftId
      headline: $headline
      order: $order
      afterSectionId: $afterSectionId
      instructions: $instructions
    ) {
      ...BlogPostBuilderOutlineSection
    }
  }
  ${FRAGMENT_PROJECT_BLOG_CONTENT_OUTLINE_SECTION}
`;

type Variables = BackendMutationCreateBlogPostBuilderOutlineSectionArgs;

export const createBlogPostBuilderOutlineSection = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<BlogOutlineSection>(result.data);
};
